import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';

export default function LendingFAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "Is Aramco Leads Pro a direct lender?",
      answer: "No. Aramco Leads Pro is NOT a direct lender. We are a lead generation and CRM platform that connects consumers with licensed lending partners. We do not make loans, extend credit, or make lending decisions. All lending activities are performed by independent, licensed financial institutions."
    },
    {
      question: "Who makes the lending decisions?",
      answer: "All lending decisions are made by our partner lenders, not by Aramco Leads Pro. Partner lenders are independent financial institutions that are licensed and regulated by state and federal authorities. They review applications, perform credit checks, set loan terms, and approve or deny loan requests."
    },
    {
      question: "What is Aramco Leads Pro's role in the lending process?",
      answer: "Our role is to connect consumers interested in financial services with licensed lending partners. We provide information about available loan products, facilitate communication between consumers and lenders, and send updates about application status. We do not participate in underwriting, credit decisions, or loan servicing."
    },
    {
      question: "Do you access my credit report?",
      answer: "No. Aramco Leads Pro does not access credit reports or perform credit checks. Only our partner lenders (with your permission) will access your credit information as part of their loan application and underwriting process."
    },
    {
      question: "What information do you share with lenders?",
      answer: "When you express interest in a loan product through our platform, we may share your contact information and loan inquiry details with one or more licensed lending partners. This allows them to contact you with loan offers. You can review our Privacy Policy for complete details on information sharing."
    },
    {
      question: "Am I obligated to accept a loan offer?",
      answer: "No. You are never obligated to accept any loan offer. If a partner lender contacts you with a loan offer, you are free to accept, decline, or negotiate terms. You can also opt out of receiving future loan offers at any time by replying STOP to any SMS message."
    },
    {
      question: "Who sets the interest rates and loan terms?",
      answer: "Interest rates, loan amounts, repayment terms, and all other loan conditions are set by the partner lenders, not by Aramco Leads Pro. Each lender has its own underwriting criteria and pricing. Terms vary based on the lender and your individual creditworthiness."
    },
    {
      question: "What if I have a problem with a loan or lender?",
      answer: "Since loans are provided by partner lenders (not Aramco Leads Pro), any issues with loan terms, payments, or lender practices should be directed to the specific lender. Each lender has its own customer service and dispute resolution process. You can also contact your state's financial regulatory authority if needed."
    },
    {
      question: "How do I opt out of receiving loan offers?",
      answer: "You can opt out at any time by replying STOP to any SMS message you receive from us. You can also contact us at compliance@aramcoleadspro.com to request removal from our lending communications. Opting out will not affect any existing loan or relationship you have with a partner lender."
    },
    {
      question: "Are your partner lenders licensed?",
      answer: "Yes. All of our partner lenders are licensed financial institutions that comply with applicable state and federal lending regulations. Each lender is independently licensed and regulated by the appropriate authorities in the states where they operate."
    },
    {
      question: "Does opting in guarantee loan approval?",
      answer: "No. Opting in to receive loan offers does not guarantee approval for any loan. All loan applications are subject to the partner lender's underwriting criteria, credit approval process, and lending policies. Approval depends on factors like creditworthiness, income, and debt-to-income ratio."
    },
    {
      question: "What regulations do you comply with?",
      answer: "Aramco Leads Pro complies with TCPA (Telephone Consumer Protection Act), CFPB guidelines, Truth in Lending Act (TILA), Fair Lending practices, and all applicable state and federal regulations for lead generation and consumer communications. Our partner lenders comply with all lending-specific regulations."
    },
    {
      question: "How is my data protected?",
      answer: "We use industry-standard security measures including encrypted data transmission, secure database storage, limited access controls, and regular security audits. Your information is only shared with licensed lending partners with your consent. See our Privacy Policy for complete details."
    },
    {
      question: "Can I choose which lenders to work with?",
      answer: "When you submit a loan inquiry, we may share your information with multiple partner lenders. You are free to choose which lender (if any) you want to work with based on the offers you receive. You can decline offers from any or all lenders."
    },
    {
      question: "What types of loans are available?",
      answer: "Our partner lenders offer various loan products including personal loans, debt consolidation loans, home improvement loans, and other consumer financing options. Specific products, amounts, and terms vary by lender and your qualifications."
    }
  ];

  return (
    <>
      <Helmet>
        <title>Lending FAQ - Aramco Leads Pro</title>
        <meta name="description" content="Frequently asked questions about Aramco Leads Pro's lending services, partner lenders, and how our lead generation platform works." />
      </Helmet>

      <div style={{ background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)', color: 'white', padding: '4rem 2rem', textAlign: 'center' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h1 style={{ fontSize: '3rem', fontWeight: '800', marginBottom: '1rem' }}>Lending Services FAQ</h1>
          <p style={{ fontSize: '1.25rem', opacity: 0.95 }}>Common questions about our lending lead generation platform</p>
        </div>
      </div>

      <div style={{ maxWidth: '900px', margin: '0 auto', padding: '4rem 2rem' }}>
        
        {/* Critical Disclaimer */}
        <div style={{ background: '#fef2f2', border: '2px solid #ef4444', borderRadius: '12px', padding: '2rem', marginBottom: '3rem' }}>
          <div style={{ display: 'flex', alignItems: 'start', gap: '1rem' }}>
            <div style={{ fontSize: '2rem' }}>⚠️</div>
            <div>
              <h2 style={{ fontSize: '1.5rem', fontWeight: '700', color: '#991b1b', marginBottom: '0.5rem' }}>
                Important: We Are NOT a Direct Lender
              </h2>
              <p style={{ color: '#7f1d1d', lineHeight: '1.6' }}>
                Aramco Leads Pro is a <strong>lead generation and CRM platform</strong>. We connect consumers 
                with licensed lending partners but do not make loans, extend credit, or make lending decisions. 
                All lending activities are performed by independent, licensed financial institutions.
              </p>
            </div>
          </div>
        </div>

        {/* FAQ Items */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          {faqs.map((faq, index) => (
            <div 
              key={index}
              style={{
                background: 'white',
                border: '1px solid #e5e7eb',
                borderRadius: '12px',
                overflow: 'hidden',
                boxShadow: openIndex === index ? '0 4px 12px rgba(0,0,0,0.1)' : 'none',
                transition: 'all 0.3s ease'
              }}
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                style={{
                  width: '100%',
                  padding: '1.5rem',
                  textAlign: 'left',
                  background: openIndex === index ? '#f9fafb' : 'white',
                  border: 'none',
                  cursor: 'pointer',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  fontSize: '1.1rem',
                  fontWeight: '600',
                  color: '#1f2937',
                  transition: 'background 0.3s ease'
                }}
              >
                <span>{faq.question}</span>
                <svg 
                  style={{
                    width: '24px',
                    height: '24px',
                    transform: openIndex === index ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.3s ease',
                    flexShrink: 0,
                    marginLeft: '1rem'
                  }}
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              
              {openIndex === index && (
                <div style={{
                  padding: '0 1.5rem 1.5rem',
                  color: '#4b5563',
                  lineHeight: '1.8',
                  fontSize: '1rem'
                }}>
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Additional Resources */}
        <div style={{ marginTop: '4rem', background: '#f9fafb', padding: '2rem', borderRadius: '12px', border: '1px solid #e5e7eb' }}>
          <h2 style={{ fontSize: '1.5rem', fontWeight: '700', marginBottom: '1rem' }}>Additional Resources</h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
            <a href="/lending-compliance" style={{ color: '#1e40af', textDecoration: 'none', fontWeight: '500' }}>
              → Lending Compliance & Disclosures
            </a>
            <a href="/privacy" style={{ color: '#1e40af', textDecoration: 'none', fontWeight: '500' }}>
              → Privacy Policy
            </a>
            <a href="/terms" style={{ color: '#1e40af', textDecoration: 'none', fontWeight: '500' }}>
              → Terms of Service
            </a>
            <a href="/opt-out" style={{ color: '#1e40af', textDecoration: 'none', fontWeight: '500' }}>
              → Opt-Out Instructions
            </a>
          </div>
        </div>

        {/* Contact */}
        <div style={{ marginTop: '3rem', textAlign: 'center', padding: '2rem', background: '#dbeafe', borderRadius: '12px' }}>
          <h3 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#1e40af', marginBottom: '0.5rem' }}>
            Still Have Questions?
          </h3>
          <p style={{ color: '#1e3a8a', marginBottom: '1rem' }}>
            Contact our compliance team for more information
          </p>
          <a 
            href="mailto:compliance@aramcoleadspro.com"
            style={{
              display: 'inline-block',
              padding: '0.75rem 2rem',
              background: '#1e40af',
              color: 'white',
              textDecoration: 'none',
              borderRadius: '8px',
              fontWeight: '600',
              transition: 'background 0.3s ease'
            }}
          >
            Email Compliance Team
          </a>
        </div>
      </div>
    </>
  );
}
